import { Divider, Grid } from "@material-ui/core";
import React from 'react';
import Utils from "../../providers/Utils";



const FacturiRowsTable = (props) => {



    const u = new Utils()

    return (

        <Grid container>
            {props.facturi.map((f, idx) => {
                return (
                    <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>
                            <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.nrFactura}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{f.document}</span>

                            </Grid>

                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.dataEmitere}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{u.ParseDataFromSql(f.data_emitere)}</span>

                            </Grid>
                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.dataIncasarii}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{u.ParseDataFromSql(f.data_ultimei_incasari)}</span>

                            </Grid>

                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.depasire}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color:Number(f.zile_depasite) > 0 ? 'rgb(211	58	64)' : '' }}>{f.zile_depasite} Zile</span>

                            </Grid>

                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.valoareFactura}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{f.valoare} Lei</span>

                            </Grid>



                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={1} sm={1} md={1} lg={1} xl={1}>



                                <i onClick={() => { props.editFactura(f) }} style={{ cursor: 'pointer' }} className='material-icons'>edit</i>
                                <i onClick={() => { props.deleteFactura(f) }} style={{ marginRight: 20, cursor: 'pointer' }} className='material-icons'>delete</i>




                            </Grid>
                        </Grid>
                        <Divider className='pm-divider' style={{ marginTop: 20 }} />
                    </Grid>
                )
            })}



        </Grid>

    )
}



export default FacturiRowsTable;